import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';
import { Button } from './ui/button';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Small delay so it doesn't flash on page load
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookie_consent', 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[9999] bg-white border-t border-slate-200 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] animate-in slide-in-from-bottom duration-500"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="w-5 h-5 text-sky-600 mt-0.5 flex-shrink-0" />
          <p className="text-sm text-slate-600">
            Utilizamos cookies propias y de terceros para el funcionamiento de la plataforma y mejorar tu experiencia.
            Puedes obtener más información en nuestra{' '}
            <Link to="/politica-cookies" className="text-sky-600 hover:underline font-medium">
              Política de Cookies
            </Link>.
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0 w-full sm:w-auto">
          <Button
            variant="outline"
            size="sm"
            onClick={handleReject}
            data-testid="cookie-reject-btn"
            className="flex-1 sm:flex-initial"
          >
            Rechazar
          </Button>
          <Button
            size="sm"
            onClick={handleAccept}
            data-testid="cookie-accept-btn"
            className="flex-1 sm:flex-initial bg-sky-600 hover:bg-sky-700"
          >
            Aceptar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
